import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { countMeetingTypes, createMeetingType, deleteMeetingType, getMeetingType, queryMeetingTypes, searchMeetingTypes, updateMeetingType } from '@wix/ambassador-ai-scheduling-assistant-v1-meeting-type/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { MeetingTypeClientBase } from './MeetingTypeClientBase';
export class MeetingTypeClient extends HttpBaseClient(MeetingTypeClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryMeetingTypesImpl", queryMeetingTypes);
    _defineProperty(this, "searchMeetingTypesImpl", searchMeetingTypes);
    _defineProperty(this, "getMeetingTypeImpl", getMeetingType);
    _defineProperty(this, "countMeetingTypesImpl", countMeetingTypes);
    _defineProperty(this, "createMeetingTypeImpl", createMeetingType);
    _defineProperty(this, "updateMeetingTypeImpl", updateMeetingType);
    _defineProperty(this, "deleteMeetingTypeImpl", deleteMeetingType);
  }
}
//# sourceMappingURL=MeetingTypeClientHttp.js.map